


























import { defineComponent, PropType } from "@vue/composition-api";
import InputFileMixin from "@/mixins/InputFileMixin";
import useUploadedFilePreview from "@/hooks/useUploadedFilePreview";
import config from "@/config";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import UploadedFilesEditModal from "@/components/UploadedFilesEditModal";

export default defineComponent({
  name: "BaseInputFileWithPreview",
  components: { UploadedFilesEditModal, BaseInputFile, BaseIcon },
  mixins: [InputFileMixin(config.fileExtensions)],
  props: {
    multiple: { type: Boolean, default: false },
    showUploader: { type: Boolean, default: false },
    accept: { type: Array as PropType<string[]> },
  },
  setup() {
    const {
      files,
      addFilesFromDevice,
      updateUploadedFile,
      removeFileFromUploadedList,
      closeEditModal,
      uploadFiles,
    } = useUploadedFilePreview();

    return {
      files,
      addFilesFromDevice,
      updateUploadedFile,
      removeFileFromUploadedList,
      closeEditModal,
      uploadFiles,
    };
  },
});
